import { render } from "./teaSubjectEchart.vue?vue&type=template&id=bb3255e4&scoped=true"
import script from "./teaSubjectEchart.vue?vue&type=script&lang=js"
export * from "./teaSubjectEchart.vue?vue&type=script&lang=js"

import "./teaSubjectEchart.vue?vue&type=style&index=0&id=bb3255e4&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3255e4"]])

export default __exports__